import React from 'react';
import {IconButton, Layout} from 'components';

type Props = {
  onSearch: () => void;
  onAdd: () => void;
};

export const PrizesToolbar: React.FC<Props> = ({onSearch, onAdd}) => {
  return (
    <Layout horizontal adjustRight flex={1}>
      <IconButton icon="Search" onClick={onSearch} />
      <IconButton icon="Add" onClick={onAdd} />
    </Layout>
  );
};
